export const PUSH_NOTIFICATION_TYPES = {
  CHRISTMAS: 'CHRISTMAS',
  FATHERS_DAY: 'FATHERS_DAY',
  GET_WELL: 'GET_WELL',
  HANUKKAH: 'HANUKKAH',
  HAPPY_BIRTHDAY: 'HAPPY_BIRTHDAY',
  HOLIDAYS: 'HOLIDAYS',
  JUST_BECAUSE: 'JUST_BECAUSE',
  MOTHERS_DAY: 'MOTHERS_DAY',
  MOVEMBER: 'MOVEMBER',
  SAVE_THE_DATE: 'SAVE_THE_DATE',
  THANKSGIVING: 'THANKSGIVING',
  THANK_YOU: 'THANK_YOU',
  THINKING_OF_YOUR: 'THINKING_OF_YOUR',
  VALENTINES_DAY: 'VALENTINES_DAY',
};
